import { Button } from '@/components/ui/button';

// Self-hosted, optimized hero (89 KB WebP / 199 KB JPEG, 2400x865). Replaces the
// 3.7 MB / 3456px external PNG that failed to decode on low-memory devices
// (e.g. Chromebooks). External original kept as an ultimate onError fallback.
const HERO_FALLBACK = 'https://customer-assets.emergentagent.com/job_466cd153-1355-4be2-afa5-ec75ce7c4c41/artifacts/yryxyyt1_pai-hero-png.png';

export default function HeroSection() {
  return (
    <section data-testid="hero-section">
      <div className="w-full bg-[#0a1e3f]">
        <picture>
          <source srcSet="/pai-hero.webp" type="image/webp" />
          <img
            src="/pai-hero.jpg"
            alt="P.AI Global Health - Doctor-patient consultation"
            className="w-full h-auto object-cover max-h-[420px]"
            width="2400"
            height="865"
            decoding="async"
            fetchpriority="high"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = HERO_FALLBACK; }}
            data-testid="hero-image"
          />
        </picture>
      </div>
    </section>
  );
}
